module.exports = __webpack_public_path__ + "static/media/info.0761160c.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/info.svg
// module id = ./src/assets/icons/info.svg
// module chunks = 0